/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, SimpleAttributeList, simpleLocalAttribute } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData } from '@touchplan/common';

export interface ICustomFieldDropDownItemDefinition {
	label: string;
	isEnabled?: boolean;
	order?: number;
	id?: string;
	local?: boolean; // since this is a use case unsupported by SplitDta, use this flag by UI to indicate local data (not yet persisted)
}

export interface ICustomFieldDropDownDefinition {
	dataType: string;
	data: ICustomFieldDropDownItemDefinition[];
}

export class CustomFieldDropDownDefinition extends SplitData<
	ICustomFieldDropDownDefinition,
	DefaultSplitDataRenderType
> {
	protected useInPlace = true;
	protected attributeList: SimpleAttributeList = Object.assign(generateSimplestList(['dataType', 'data']), {
		prevData: simpleLocalAttribute,
	});

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}

	public databaseUpdate(data: object): void {
		super.databaseUpdate(data);
		const arr = [];
		if ((data as ICustomFieldDropDownDefinition).data) {
			//the type here is incorrect, this is not an array, but an object
			const list = (data as ICustomFieldDropDownDefinition).data;

			// convert object to array for UI data consumption
			for (const prop in list) {
				if (prop) {
					arr.push({ ...list[prop], id: prop });
				}
			}
		}

		this.database.data = arr;
	}

	// called when we add item locally via addItem(), i.e. 'add_item'
	public localDatabaseUpdate(data: ICustomFieldDropDownDefinition): void {
		super.databaseUpdate(data);
	}

	public generateDatabaseOutput(renderType?: DefaultSplitDataRenderType): object {
		const view = super.generateDatabaseOutput(renderType) as ICustomFieldDropDownDefinition;
		const arr = view.data as ICustomFieldDropDownItemDefinition[];

		if (arr?.length > 0) {
			const map = {};
			arr.forEach((item: ICustomFieldDropDownItemDefinition) => {
				map[item.id] = item;
				delete map[item.id].local;
				delete map[item.id].id;
			});
			(view.data as object) = map;
		}

		if (this.view?.data) {
			this.view.data.forEach((item) => delete item.local);
		}

		return view;
	}
}
